import { Component, HostListener, Inject, OnInit } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';

export interface DialogData {
  icon: string;
  textIcon: string;
  title: string;
  text: string;
  textExtra: string;
  textLink: string;
  linkAdress: string;
  sendSMS: () => void;
  sendWPP: () => void;
}

@Component({
  selector: 'app-model-modal-resend-password',
  templateUrl: './model-modal-resend-password.component.html',
  styleUrls: ['./model-modal-resend-password.component.scss'],
})
export class ModelModalResendPasswordComponent implements OnInit {
  public smsCode = true;
  constructor(
    public dialogRef: MatDialogRef<ModelModalResendPasswordComponent>,
    @Inject(MAT_DIALOG_DATA) public data: DialogData
  ) {}
  ngOnInit(): void {}

  onNoClick(): void {
    this.dialogRef.close();
  }

  onClick(): void {
    if (this.smsCode === true) this.data.sendSMS();
    else this.data.sendWPP();
    this.onNoClick();
  }

  @HostListener('keydown.esc')
  public onEsc() {
    this.dialogRef.close(false);
  }
}
